<template>
  <div class="mock-interview-container">模拟面试</div>
</template>
<script>
export default {
  name: "MockInterview",
};
</script>
<style lang="scss" scoped>
.mock-interview-container {
  width: 100%;
  height: 100%;
  padding: 0 24px;
}
</style>
